
export default function Contact() {
  return (
    <section id="iletisim" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            İletişime Geçin
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sorularınız için bize ulaşın, size en kısa sürede dönüş yapalım
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">İletişim Bilgileri</h3>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-fill text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Adres</h4>
                    <p className="text-gray-600">
                      Kazım Karabekir Caddesi No:91 D:28,<br />
                      Başkent İş Merkezi, 06070 Altındağ/Ankara
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-fill text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Telefon</h4>
                    <a href="tel:+903123808099" className="text-gray-600 hover:text-red-600 transition-colors block cursor-pointer">
                      0312 380 80 99
                    </a>
                    <a href="tel:+908503073704" className="text-gray-600 hover:text-red-600 transition-colors block cursor-pointer">
                      +90 850 307 3704
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-fill text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">E-posta</h4>
                    <a href="mailto:yildirimdijital@gmail.com" className="text-gray-600 hover:text-red-600 transition-colors cursor-pointer">
                      yildirimdijital@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-fill text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Çalışma Saatleri</h4>
                    <p className="text-gray-600">
                      Pazartesi - Cumartesi: 09:00 - 18:00<br />
                      Pazar: Kapalı
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100">
              <div className="w-full h-80">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3059.0234567890123!2d32.8597!3d39.9334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU2JzAwLjIiTiAzMsKwNTEnMzUuMCJF!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Yıldırım Reklam Konum"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-8 text-white shadow-2xl">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-phone-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">Hemen Arayın</h3>
              <p className="text-white/90 mb-6">
                Uzman ekibimiz size yardımcı olmak için hazır. Projeleriniz hakkında detaylı bilgi alın.
              </p>
              <a 
                href="tel:+908503073704" 
                className="inline-flex items-center justify-center w-full bg-white text-red-600 px-6 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill mr-2"></i>
                +90 850 307 3704
              </a>
            </div>

            <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-2xl p-8 text-white shadow-2xl">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-whatsapp-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-3">WhatsApp ile Yazın</h3>
              <p className="text-white/90 mb-6">
                WhatsApp üzerinden bize ulaşın, anında yanıt alın ve projelerinizi paylaşın.
              </p>
              <a 
                href="https://wa.me/908503073704" 
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full bg-white text-green-600 px-6 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill mr-2"></i>
                WhatsApp'tan Yaz
              </a>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-mail-fill text-red-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">E-posta Gönderin</h3>
              <p className="text-gray-600 mb-6">
                Detaylı bilgi ve teklif almak için e-posta gönderebilirsiniz.
              </p>
              <a 
                href="mailto:yildirimdijital@gmail.com" 
                className="inline-flex items-center justify-center w-full bg-red-600 text-white px-6 py-4 rounded-lg text-lg font-semibold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-fill mr-2"></i>
                E-posta Gönder
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
